



















































































































import { Vue, Component, Emit } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import { menuServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import { TableStripe } from '@/mixins/tableStripe';

@Component({
  components: { PagingUnit, CollapseTransition },
  mixins: [TableStripe],
})
export default class User extends Vue {
  // private queryDataForm: any = {
  //   pageNo: 1,
  //   pageSize: 10,
  // };
  private openFlag = false; // 控制左侧导航栏是否显示
  private loading: any = false; // 表格加载
  private vibs: any = false; // 编辑页展示
  private treeStatus: any = false; // 是否打开节点
  private searchFlag = false; // 控制显示查询和隐藏查询
  total = 0; // 数据总共多少条
  // 搜索栏的数据对象
  private searchFormData: any = {
    name: '', // 菜单名称
  };

  // 表格的数据对象
  tableData: any = [];

  /**
   * @desc Vue 初始化
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.getMenuListData();
  }

  /**
   * @desc 分页获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getMenuListData() {
    this.loading = true;
    // 发起接口请求，获取分页数据
    menuServe
      .sysMenuList({
        // current: this.queryDataForm.pageNo,
        // size: this.queryDataForm.pageSize,
        name: this.searchFormData.name ? this.searchFormData.name : null,
      })
      .then((res: any) => {
        this.tableData = arrayToTree(res.data);
        // this.total = res.data.total;
        this.loading = false;
      })
      .catch((error: any) => {
        this.loading = false;
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏或查询按钮会触发事件，用于显示和隐藏搜索栏
   * @param1 暂无
   * @returns 暂无
   */
  private hideSearch() {
    this.searchFlag = !this.searchFlag;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 查询事件
   * @param1 暂无
   * @returns 暂无
   */
  private menuSearch() {
    // this.queryDataForm.pageNo = 1;
    this.getMenuListData();
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * 分页回调事件
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getMenuListData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 重置搜索的表单
   * @param1 暂无
   * @returns 暂无
   */
  private resetSearch() {
    this.searchFormData.name = '';
    // this.queryDataForm.pageNo = 1;
    // this.queryDataForm.pageSize = 10;
    this.getMenuListData();
  }

  /**
         @description: 刷新列表
         @author: cxf
         @update: cxf 2021/5/18 18:34
         **/
  private refreshTree() {
    this.getMenuListData();
  }

  /**
         @description: 展开列表
         @author: cxf
         @update: cxf 2021/5/18 18:34
         **/
  private openTree() {
    this.treeStatus = true;
    this.$nextTick(() => {
      this.forArr(this.tableData, this.treeStatus);
    });
  }

  forArr(arr: any, isExpand: any) {
    const treeNode: any = 'treeNode';
    arr.forEach((i: any) => {
      (this.$refs[treeNode] as any).toggleRowExpansion(i, isExpand);
      if (i.children) {
        this.forArr(i.children, isExpand);
      }
    });
  }

  /**
         @description: 折叠列表
         @author: cxf
         @update: cxf 2021/5/18 18:34
         **/
  private foldTree() {
    this.treeStatus = false;
    this.$nextTick(() => {
      this.forArr(this.tableData, this.treeStatus);
    });
  }

  /**
         @description: 保存排序
         @author: cxf
         @update: cxf 2021/5/18 18:34
         **/
  private saveSort() {
    // menuServe
    //         .editMenuData(this.tableData)
    //         .then((res: any) => {
    //           if (res.code === '200') {
    //             this.$message.success('保存成功');
    //             this.getMenuListData();
    //           }
    //         })
    //         .catch(() => {
    //           this.$message.error('保存失败,请稍后重试!');
    //         });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 新增，编辑按钮点击跳转。
   * @param1 暂无
   * @returns 暂无
   */
  private addMenu() {
    this.$emit('update:showFlag', 4); // 跳转到新增页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击编辑图标触发，跳转到编辑页面。
   * @param1 row: 要编辑的这一行的数据对象
   * @returns 暂无
   */
  @Emit('getRow')
  private addAndEditMenu(data?: any) {
    this.$emit('update:showFlag', 2); // 跳转到编辑页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击加图标触发，进入添加下级公司界面.
   * @param1 row：是该行数据 id
   * @returns 返回值描述
   */
  @Emit('getRow')
  addNextCompany(row: string) {
    this.$emit('update:showFlag', 3); // 跳转到新增下级页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc  删除数据
   * @param1 暂无
   * @returns 暂无
   */
  private deleteMenu(id: any) {
    this.$confirm('确认要删除该条数据吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        menuServe
          .deleteMenuData(id)
          .then((res: any) => {
            this.getMenuListData(); // 重新渲染表格数据
            this.$message.success('删除成功!');
          })
          .catch((error: any) => {
            this.$message.error('删除失败,请稍后重试!');
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除！',
        });
      });
  }

  // private openTableHead() {
  //   this.$message.warning('打开表格头弹框！');
  // }
}
